import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { z } from "zod";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "../ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";
import { Check } from "lucide-react";
import axiosClient from "../../lib/axiosClient";
import { ksUserQK } from "../../lib/query-keys";

const schema = z.object({
  email: z.string().email("Adresse e-mail invalide"),
  password: z.string().min(1, "Requis"),
});
type FieldValues = z.infer<typeof schema>;

const UpdateEmailDialog = () => {
  const queryclient = useQueryClient();
  const [open, setOpen] = useState(false);
  const form = useForm<FieldValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      password: "",
      email: "",
    },
  });

  const { mutate: update, isPending } = useMutation({
    mutationFn: async (data: FieldValues) => {
      await axiosClient.post("/users/update-email", {
        newEmail: data.email.trim().toLowerCase(),
        password: data.password,
      });
    },
    onSuccess: () => {
      setOpen(false);
      toast.success("Votre adresse e-mail a été modifiée");
      queryclient.invalidateQueries({ queryKey: [ksUserQK] });
    },
    onError: (err: any) => {
      console.error(err.response?.data || err);
      toast.error(err.response?.data?.message || `Une erreur s'est produite`);
    },
  });
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpened) => {
        form.reset();
        setOpen(isOpened);
      }}
    >
      <DialogTrigger asChild>
        <Button>Modifier l'adresse e-mail</Button>
      </DialogTrigger>
      <DialogContent className="max-w-[400px]">
        <Form {...form}>
          <form onSubmit={form.handleSubmit((data) => update(data))}>
            <DialogHeader>
              <DialogTitle>Modification d'adresse e-mail</DialogTitle>
            </DialogHeader>

            <div className="flex flex-col gap-4 my-5">
              {/* Body */}
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Mot de passe</FormLabel>
                    <FormControl>
                      <Input type="password" required {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="email"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Nouvelle adresse e-mail</FormLabel>
                    <FormControl>
                      <Input type="email" required {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>

            <DialogFooter>
              <DialogClose asChild className="mr-2">
                <Button variant={"outline"}>Fermer</Button>
              </DialogClose>
              <Button icon={<Check />} loading={isPending}>
                Valider
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateEmailDialog;
